import { Link } from "react-router-dom";

const HeroBrand = () => {
  return (
    <section>
      <div className="relative w-full h-[50vh] lg:h-[65vh] overflow-hidden">
        <img
          src="/images/hero-lifestyle.jpeg"
          alt="Custom 3D map art in a modern interior"
          loading="eager"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition: "50% 35%" }}
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, transparent 0%, transparent 60%, rgba(250,250,248,0.3) 100%)" }} />
      </div>

      <div className="text-center py-16 lg:py-20 px-6" style={{ backgroundColor: "var(--brand-bg)" }}>
        <h1
          className="mb-5"
          style={{
            fontFamily: "var(--font-hero)",
            fontWeight: 400,
            color: "var(--brand-text)",
            fontSize: "clamp(1.875rem, 5vw, 3.5rem)",
            lineHeight: 1.1,
          }}
        >
          Your World, <em>Artfully Mapped.</em>
        </h1>
        <p
          className="mb-8 max-w-[42rem] mx-auto"
          style={{
            fontFamily: "var(--font-body)",
            color: "var(--brand-muted)",
            fontSize: "clamp(1rem, 1.5vw, 1.125rem)",
            lineHeight: 1.6,
            fontWeight: 300,
          }}
        >
          Discover custom 3D city map art pieces, hand-crafted to tell your story. Bring the places you love into your home.
        </p>
        <div className="text-center">
          <Link
            to="/studio"
            className="inline-flex items-center gap-3 rounded-full px-10 py-4 text-base font-semibold uppercase tracking-wider text-white"
            style={{ backgroundColor: "var(--sage-400)" }}
          >
            Start Designing Your Map
          </Link>
          <p className="mt-4 text-sm" style={{ fontFamily: "var(--font-body)", color: "var(--brand-light)" }}>
            Starting at $55 &middot; Free shipping &middot; 3D preview included
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroBrand;
